<template>
  <container>
    <div slot="bottom_box_content">
        <component :is="curBottomComponent"></component>
    </div>
  </container>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import investmentElecCollectionStoreModule from '@/store/modules/investmentElecCollection'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    Bottom: () => import('./collectionComponents/Bottom.vue')
  },
  created () {
    if (!this.$store.hasModule('investmentElecCollection')) {
      this.$store.registerModule('investmentElecCollection', investmentElecCollectionStoreModule)
    }
  },
  mounted () {
    this.setShowLeftBlock(false)
    this.setShowRightBlock(false)
    this.setShowMap(false)
    this.setBottomHeight('90%')
    this.setLeftComponent('')
    this.setRightComponent('')
    this.setBottomComponent('Bottom')
  },
  destroyed () {
    this.$store.unregisterModule('investmentElecCollection')
  }
}
</script>
